export enum MarketOrdering {
  newestFirst = '-date_created',
  oldestFirst = 'date_created',
  highestPrice = '-price',
  lowestPrice = 'price',
  closestDue = '-expiration_time',
  furthestDue = 'expiration_time',
}
